import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorPageComponent } from './error-page/error-page.component';
import { LayoutComponent } from './layout/layout.component';
import { CatalogsResolver } from './shared/resolvers/catalogs.resolver';
import { AdAccountsResolver } from './shared/resolvers/ad-accounts.resolver';
import { StartPageComponent } from '@fb-tool-front/start-page/start-page.component';
import { OnboardingCatalogsGuard } from './catalogs/guards/onboarding-catalogs.guard';
import { OnboardingOverlaysStepperGuard } from './catalogs/guards/onboarding-overlays-stepper.guard';
import { AuthClientGuard } from './core/guards/auth-client.guard';
import { LoginGuard } from './core/guards/login.guard';
import { ResetPasswordGuard } from './core/guards/reset-password-user.guard';
import { ConfirmUserGuard } from './core/guards/confirm-user.guard';
import { AuthGuard } from './core/guards/auth.guard';
import { FacebookAuthGuard } from './core/guards/facebook-auth.guard';
import { ShowStatisticsGuard } from '@fb-tool-front/core/guards/show-statistics.guard';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthClientGuard],
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'videos',
        loadChildren: () => import('./videos/videos.module').then(m => m.VideosModule)
      },
      {
        path: 'statistics',
        loadChildren: () => import('./statistics/statistics.module').then(m => m.StatisticsModule),
        canActivate: [ShowStatisticsGuard]
      },
      {
        path: 'home',
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
      },
      {
        path: 'home-overlays',
        loadChildren: () =>
          import('./home/overlays/overlays-stepper.module').then(m => m.OverlaysStepperModule),
        canActivate: [OnboardingOverlaysStepperGuard]
      },
      {
        path: 'overlays',
        canActivate: [OnboardingCatalogsGuard],
        resolve: {
          catalogs: CatalogsResolver
        },
        loadChildren: () => import('./catalogs/catalogs.module').then(m => m.CatalogsModule)
      },
      {
        path: 'settings',
        loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
        resolve: {
          adAccounts: AdAccountsResolver,
          catalogs: CatalogsResolver
        },
        data: {
          withoutCache: true
        }
      },
      { path: 'start', component: StartPageComponent },
      { path: 'error', component: ErrorPageComponent }
    ]
  },
  {
    path: 'reset',
    canActivate: [LoginGuard, ResetPasswordGuard],
    loadChildren: () =>
      import('./auth/reset-password-page/reset-password-page.module').then(
        m => m.ResetPasswordPageModule
      )
  },
  {
    path: 'login',
    canActivate: [LoginGuard, FacebookAuthGuard],
    loadChildren: () => import('./auth/login-page/login-page.module').then(m => m.LoginPageModule)
  },
  {
    path: 'signup',
    canActivate: [LoginGuard, FacebookAuthGuard],
    loadChildren: () =>
      import('./auth/quick-sign-up-page/quick-sign-up-page.module').then(
        m => m.QuickSignUpPageModule
      )
  },
  {
    path: 'confirm',
    canActivate: [LoginGuard, ConfirmUserGuard],
    loadChildren: () =>
      import('./auth/verify-page/verify-page.module').then(m => m.VerifyPageModule)
  },
  {
    path: 'client',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./auth/client-page/client-page.module').then(m => m.ClientPageModule)
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
